<template>
    <span v-text="answer.content"></span>
</template>
<script>
export default {
    props: ['question', 'answer','answer_given'],
    methods: {
        onAnswerSelection(){
            Event.$emit('question_'+ this.question +'_answered', { active_id: this.answer.id });
            Event.$emit('page_answer_given', { question_id: this.question, answer_id: this.answer.id });
        }
    },
    created() {
        Event.$on('question_'+ this.question +'_answered', ( $event ) => ( this.is_active = ($event.active_id == this.answer.id ) ? true : false ) );
        Event.$on('question_'+ this.question +'_answered', ( $event ) => ( this.is_greyed = ($event.active_id == this.answer.id ) ? false : true ) );
    },
    data() {
        return {
            is_active: false,
            is_greyed: false
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/range-answer.vue